<template>
  <v-container fluid>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/team/sales' }"
        >รายชื่อทีมขาย</el-breadcrumb-item
      >
    </el-breadcrumb>

    <el-card class="mt-5">
      <div slot="header" class="clearfix">
        <div class="px-1 pt-2"></div>
      </div>
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="isLoading"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :mobile-breakpoint="`10`"
        @page-count="pageCount = $event"
        hide-default-footer
        class="elevation-0"
      >
        <template v-slot:item.action="{ item }">
          <div>
            <el-button
              type="text"
              size="small"
              class="mr-2"
              @click="openItem(item)"
              >ดูรายละเอียด</el-button
            >
          </div>
        </template>
        <template v-slot:item.status="{ item }">
          <div style="width: 60px">
            <v-btn icon color="green" v-if="item.user_info.status == 'active'">
              <i class="far fa-check-circle"></i>
            </v-btn>
            <v-btn icon color="red" v-if="item.user_info.status == 'inactive'">
              <i class="far fa-times-circle"></i>
            </v-btn>
            <v-btn
              icon
              color="yellow"
              v-if="item.user_info.status == 'register'"
            >
              <i class="fas fa-exclamation-triangle"></i>
            </v-btn>
          </div>
        </template>
        <template v-slot:item.fullname="{ item }">
          <div style="width: 120px">
            {{ item.user_info.firstname }} {{ item.user_info.lastname }}
          </div>
        </template>
        <template v-slot:item.mobile="{ item }">
          <div style="width: 120px">
            {{ item.user_info.mobile }}
          </div>
        </template>
      </v-data-table>
      <div
        style="
          position: fixed;
          bottom: 10px;
          right: 10px;
          z-index: 9;
          width: 100%;
        "
      >
        <v-pagination
          circle
          v-model="page"
          :total-visible="5"
          :length="pageCount"
        ></v-pagination>
      </div>
    </el-card>
  </v-container>
</template>
<script>
import Service from "@/services";
export default {
  data() {
    return {
      isLoading: true,
      list: [],
      results: [],
      total: 0,
      page: 1,
      itemsPerPage: 25,
      pageCount: 0,
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "user_id",
        },
        { text: "", value: "action", sortable: false },
        { text: "สถานะ", value: "status", sortable: false },
        { text: "ชื่อ", width: "180px", value: "fullname", sortable: false },
        {
          text: "เบอร์มือถือ",
          width: "180px",
          value: "mobile",
          sortable: false,
        },
        {
          text: "Custom Field 1",
          width: "300px",
          value: "custom_field_1",
          sortable: false,
        },
        {
          text: "Custom Field 2",
          width: "300px",
          value: "custom_field_2",
          sortable: false,
        },
        {
          text: "Custom Field 3",
          width: "300px",
          value: "custom_field_3",
          sortable: false,
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      Service.Team.list({ position: "sale" }).then((res) => {
        this.list = res.data;
        console.log(this.list);
        this.results = this.list;
        this.isLoading = false;
      });
    }, 2000);
  },
  methods: {
    openItem(item) {
      console.log(item);
    },
  },
};
</script>
